import actionTypes from 'dashboard/actions/cumulative-winners/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_CUMULATIVE_WINNERS_HISTORY_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/cumulative-winners/items.js